// extracted by mini-css-extract-plugin
export default {"storeTitle":"Gi_3c0ZRpvgXxJOEA3lH","user":"CWtHrv4dDSvDUAzywfjv"};